import React from 'react';
import { SunIcon, MoonIcon, ComputerDesktopIcon } from '@heroicons/react/24/outline';
import { useTheme } from '@/contexts/ThemeContext';

export const ThemeToggle: React.FC = () => {
  const { theme, setTheme, isDark } = useTheme();

  const themes = [
    { value: 'light' as const, label: '라이트', icon: SunIcon },
    { value: 'dark' as const, label: '다크', icon: MoonIcon },
    { value: 'system' as const, label: '시스템', icon: ComputerDesktopIcon },
  ];

  return (
    <div className="relative">
      <div className="flex items-center space-x-1 bg-gray-100 dark:bg-dark-card rounded-lg p-1">
        {themes.map(({ value, label, icon: Icon }) => (
          <button
            key={value}
            onClick={() => setTheme(value)}
            className={`
              flex items-center space-x-1 px-3 py-1.5 rounded-md text-sm font-medium transition-colors
              ${
                theme === value
                  ? 'bg-white dark:bg-dark-sidebar text-gray-900 dark:text-dark-text-primary shadow-sm'
                  : 'text-gray-600 dark:text-dark-text-secondary hover:text-gray-900 dark:hover:text-dark-text-primary'
              }
            `}
          >
            <Icon className="w-4 h-4" />
            <span className="hidden sm:inline">{label}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export const SimpleThemeToggle: React.FC = () => {
  const { theme, isDark, setTheme } = useTheme();

  const handleToggle = () => {
    if (theme === 'light') {
      setTheme('dark');
    } else if (theme === 'dark') {
      setTheme('system');
    } else {
      setTheme('light');
    }
  };

  const getIcon = () => {
    if (theme === 'light') return <SunIcon className="w-5 h-5" />;
    if (theme === 'dark') return <MoonIcon className="w-5 h-5" />;
    return <ComputerDesktopIcon className="w-5 h-5" />;
  };

  const getLabel = () => {
    if (theme === 'light') return '다크 모드로 전환';
    if (theme === 'dark') return '시스템 모드로 전환';
    return '라이트 모드로 전환';
  };

  return (
    <button
      onClick={handleToggle}
      className="p-2 rounded-lg text-gray-600 dark:text-dark-text-secondary hover:bg-gray-100 dark:hover:bg-dark-card transition-colors"
      aria-label={getLabel()}
      title={`현재: ${theme === 'light' ? '라이트' : theme === 'dark' ? '다크' : '시스템'} 모드`}
    >
      {getIcon()}
    </button>
  );
};